<template>
  <div class="search-content">
    <div
      v-if="showNav === true"
      class="search-nav">
      <div
        class="search-nav-back"
        @click="back()">
        <img src="../assets/images/nav/back1.png" />
      </div>
      <h4>{{pageTitle}}</h4>
      <div
        class="search-nav-search"
        @click="itemFun()">
        <img src="../assets/images/home/search.png" />
      </div>
    </div>
    <div class="navbar-content">
      <div class="sg-tag">
        <span
          v-for="(item, index) in videoSortList"
          :key="index"
          :class="{ tasActive : queryData.orderby === item.value }"
          class="sg-tag-item"
          @click="sortHandler(item.value)">{{item.title}}</span>
      </div>
      <van-tabs
        v-model="videoTypeId"
        type="card"
        title-inactive-color="#fff"
        title-active-color
        background="#111111"
        animate
        swipeable
        :swipe-threshold="swipeThreshold"
        @click="typeHandler">
        <van-tab
          v-for="item in videoTypeList"
          :key="item.id"
          :title="item.name"
          :name="item.id"></van-tab>
      </van-tabs>
    </div>
    <refresh-list
      class="search-content-list"
      :refresh-loading.sync="refreshLoading"
      :list-loading.sync="listLoading"
      :finished="finished"
      :error.sync="error"
      @refresh="onRefresh"
      @load="onLoad">
      <template v-if="layout === 'grid'">
        <ul class="search-content-list-view">
          <li
            v-for="item in videoList"
            :key="item.id"
            class="search-content-list-view-cell"
            @click="goPlayVideo(item.id)">
            <div class="search-content-list-logo">
              <base-image
                class="search-content-list-logo-img"
                fit="cover"
                encrypt
                :ratio="360/203"
                :url="item.coverbase64.url"
                :type="item.coverbase64.type"/>
            </div>
            <p class="search-content-list-title">{{item.title}}</p>
          </li>
        </ul>
      </template>
      <template v-else-if="layout === 'list'">
        <div
          v-for="(video, index) in videoList"
          :key="video.id"
          class="video-item">
          <a
            v-show="isShowAd"
            v-if="index % 5 === 0 && ad.length > 0"
            :href="ad[(index / 5) % ad.length].url"
            target="_blank">
            <base-image
              style="margin-bottom: 15px;"
              class="video-item-img"
              :ratio="690/300"
              :url="ad[(index / 5) % ad.length].imgbase64.url"
              :type="ad[(index / 5) % ad.length].imgbase64.type"
              encrypt/>
          </a>
          <video-block
            :video="video"
            @click.native="goPlayVideo(video.id)"></video-block>
        </div>
      </template>
    </refresh-list>
  </div>
</template>
<script>
import baseImage from '@/components/baseImage'
import refreshList from '@/components/refreshList'
import { selectItemList } from '@/API/home'
import { selectList } from '@/API/list'
import { adList } from '@/API/find'
import videoBlock from '@/views/find/components/videoBlock'
import { shuffle } from '@/utils/index'
import { mapState } from 'vuex'

const DEFAULT_ORDERBY = 'new'

export default {
  name: 'list',
  components: {
    baseImage,
    refreshList,
    videoBlock
  },
  props: {
    showNav: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: 'list'
    }
  },
  data () {
    return {
      videoSortList: [
        { title: '最新', value: 'new' },
        { title: '最热', value: 'hot' }
      ],
      videoTypeList: [],
      videoList: [],
      videoTypeId: 0,
      queryData: {
        orderby: DEFAULT_ORDERBY,
        page: 1
      },
      refreshLoading: false,
      listLoading: false,
      finished: false,
      error: false,
      ad: []
    }
  },
  computed: {
    pageTitle () {
      const typeData = this.videoTypeList.filter(type => type.id === this.videoTypeId)
      return typeData[0] ? typeData[0].name : ''
    },
    swipeThreshold () {
      return this.$store.getters.device === 'phone' ? 4 : 7
    },
    ...mapState([
      'isShowAd'
    ])
  },
  async created () {
    this.videoTypeId = +this.$route.query.typeId || 0
    this.queryData.orderby = this.$route.query.orderby || DEFAULT_ORDERBY
    await this.getVideoTypeList()
    this.adHandler()
  },
  methods: {
    async onLoad () {
      await this.getVideoList()
    },
    async onRefresh () {
      this.videoList = []
      this.queryData.page = 1
      await this.adHandler()
      await this.getVideoList()
      this.$toast('刷新成功')
      this.refreshLoading = false
    },
    replaceQueryString (key, value) {
      const { name, query } = this.$route
      this.$router.replace({
        name,
        query: {
          ...query,
          [key]: value
        }
      })
    },
    async typeHandler (id) {
      if (id === +this.$route.query.typeId) return
      this.replaceQueryString('typeId', id)
      await this.onRefresh()
    },
    async sortHandler (value) {
      if (value === this.$route.query.orderby) return
      this.queryData.orderby = value
      this.replaceQueryString('orderby', value)
      await this.onRefresh()
    },
    async getVideoTypeList () {
      await selectItemList()
        .then(res => {
          this.videoTypeList = [
            {
              id: 0,
              name: '全部',
              icopath: null,
              order: 0,
              icobase64: {
                url: null,
                type: null
              }
            },
            ...res.rescont
          ]
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getVideoList () {
      try {
        const res = await selectList({ type: this.videoTypeId, params: this.queryData })
        const { data, next_page_url: nextPageUrl } = res.rescont
        this.videoList = this.queryData.page === 1 ? data : this.videoList.concat(data)
        this.queryData.page = this.queryData.page + 1
        if (nextPageUrl === null) {
          this.listLoading = false
          this.finished = true
          return
        }
      } catch (err) {
        console.log(err)
        this.error = true
      }
      this.finished = false
      this.listLoading = false
    },
    itemFun () {
      this.$router.push({ path: '/search' })
    },
    goPlayVideo (id) {
      this.$router.push({
        path: '/playVideo',
        query: {
          id
        }
      })
    },
    async getAd () {
      await adList().then(data => {
        if (data.rescont) {
          this.ad = shuffle(data.rescont)
        }
      })
    },
    async adHandler () {
      if (!this.isShowAd) return
      if (this.layout === 'grid') return
      if (this.ad.length === 0) {
        await this.getAd()
      } else {
        this.ad = shuffle(this.ad)
      }
    },
    back () {
      this.$router.go(-1) // 返回上壹層
    }
  }
}
</script>
<style>
.van-tabs--card > .van-tabs__wrap {
  box-sizing: border-box;
  height: 44px !important;
  padding: 7px 0 !important;
}

.van-tabs__nav--card {
  box-sizing: border-box;
  height: 26px !important;
  margin: 0 5px;
  border: 0 solid #ee0a24 !important;
  border-radius: 2px;
}

.van-tabs__nav--card .van-tab {
  line-height: 24px;
  border-right: 0 solid #eab87f !important;
}

.van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff !important;
  background-color: #eab87f !important;
  border-radius: 16px;
}

.tasActive {
  background-color: #eab87f !important;
}

.sg-tag {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: left;
  width: 100%;
  height: 44px;
  padding: 10px 5px;
}

.sg-tag-item {
  box-sizing: border-box;
  height: 24px;
  padding: 2px 10px;
  margin-left: 10px;
  font-size: 13px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #444;
  border-radius: 15px;
}

.search-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.search-nav {
  position: absolute top：0px;
  right: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 0 40px;
  font-size: 18px;
  font-weight: 600;
  line-height: 44px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}

.search-nav h4 {
  width: 100%;
  height: 44px;
  padding: 0 0;
  margin: 0 0;
  font-weight: 600;
  line-height: 44px;
  color: #fff;
}

.search-nav-back {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 40px;
  height: 44px;
  padding: 5px 10px;
}

.search-nav-back img {
  width: 14px;
  height: 24px;
}

.search-nav-search {
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  width: 40px;
  height: 44px;
  padding: 5px 10px;
}

.search-nav-search img {
  width: 24px;
  height: 24px;
}

.navbar-content {
  position: relative;
  width: 100%;
  height: 90px;
  background-color: #111;
}

.search-content-list {
  flex: 1;
  width: 100%;
  overflow: auto;
}
.search-content-list::-webkit-scrollbar { display: none; }

.search-content-list-view {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 15px 0 15px;
  margin: 0 0;
  list-style: none;
}

.search-content-list-view-cell {
  position: relative;
  width: 48%;
  margin-bottom: 10px;
}

.search-content-list-logo {
  position: relative;
  width: 100%;
}

.search-content-list-logo-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
}

.search-content-list-title {
  width: 100%;
  margin: 0 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue